



























































import { CreateElement, VNode } from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { VueRenderFunction, CSSStyleOptions } from '../common-types';
import { SwScrollView } from '../sw-scroll-view';

const cssPrefix = 'sw-content-toolbar-filter-block';

@Component({
  components: {
    SwScrollView,
  },
})
export default class SwContentToolbarFilterBlock extends SwExtendedVue {
  @Prop({ type: String, default: 'Filter' })
  title: string;

  @Prop({ type: [String, Function], required: true })
  content: string | VueRenderFunction;

  @Prop(Number)
  width: number;

  @Prop(Number)
  minWidth: number;

  @Prop({ type: Number, required: true })
  index: number;

  @Prop({ type: Boolean, default: false })
  noPadding: boolean;

  @Prop({ type: String, required: true })
  theme: string;

  cssPrefix = cssPrefix;

  get isAutoWidth(): boolean {
    return this.width === undefined;
  }

  get wrapperStyle(): CSSStyleOptions {
    const customStyle: CSSStyleOptions = {};
    if (!this.isAutoWidth) {
      customStyle.width = `${this.width}px`;
    }
    if (this.minWidth !== undefined) {
      customStyle.minWidth = `${this.minWidth}px`;
    }
    return customStyle;
  }

  private render(h: CreateElement): VNode {//tslint:disable-line
    let contentNode: VNode | VNode[] | string | null = null;

    if (typeof this.content === 'string') {
      contentNode = this.content;
    } else if (typeof this.content === 'function') {
      contentNode = this.content.call(this, h);
    }

    const rootNode = (
      <div
        class={[
          `${this.cssPrefix}`,
          `${this.cssPrefix}--${this.theme}`,
          'sw-typo-default',
          {
            'sw-flexbox__flex': this.isAutoWidth,
            'sw-flexbox__flex--auto-min-size': this.isAutoWidth,
            'sw-flexbox__flex-none': !this.isAutoWidth,
          },
        ]}
        style={this.wrapperStyle}
      >
        <div
          class={[`${this.cssPrefix}__title`, 'sw-flexbox', 'sw-flexbox--center-items',
            { [`${this.cssPrefix}__title--first`]: this.index === 0 },
          ]}
        >{this.title}</div>
        <sw-scroll-view scrollbar-theme={this.theme} class={[`${this.cssPrefix}__scroll`]}>
          <div
            class={[`${this.cssPrefix}__content`,
              {
                [`${this.cssPrefix}__content--first`]: this.index === 0,
                [`${this.cssPrefix}__content--no-padding`]: this.noPadding,
              },
            ]}
          >{contentNode}</div>
        </sw-scroll-view>
      </div>
    );

    return rootNode as VNode;
  }
}
